import { Component } from '@angular/core'
import { RoutingService } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'

@Component({
    selector: 'app-update-dispenser-agreement-info-modal',
    templateUrl: './update-dispenser-agreement-info-modal.component.html',
    styleUrls: ['./update-dispenser-agreement-info-modal.component.scss'],
    standalone: false
})
export class UpdateDispenserAgreementInfoModalComponent {
  constructor(
    private launchDialogService: LaunchDialogService,
    private routingService: RoutingService
  ) {}

  public dismissModal(): void {
    this.launchDialogService.closeDialog(null)
  }

  public updateDispenserAgreement() {
    this.launchDialogService.data$
      .subscribe((agreementCode) => {
        this.routingService.go({
          cxRoute: CustomRoutes.UPDATE_DISPENSER_AGREEMENT,
          params: { code: agreementCode }
        })
        this.dismissModal()
      })
      .unsubscribe()
  }
}
